
const CLASS_COLORS = {
    dk: '#C41E3A',
    dh: '#A330C9',
    druid: '#FF7C0A',
    hunter: '#AAD372',
    mage: '#3FC7EB',
    monk: '#00FF98',
    pala: '#F48CBA',
    priest: '#000', // '#FFFFFF',
    rogue: '#000', // '#FFF468',
    shaman: '#0070DD',
    warlock: '#8788EE',
    warrior: '#C69B6D'
}

type PredefinedSpell = {
    name: string
    ramp: number
    duration: number
    cd: number
}

export type PredefinedSpec = {
    /**
     * Must be unique
     */
    value: string
    label: string
    spells: PredefinedSpell[]
}

type PredefinedActor = {
    label: string
    color: string
    specs: PredefinedSpec[]
}

export const PREDEFINED_ACTORS: PredefinedActor[] = [
    {
        label: "Generic",
        color: CLASS_COLORS.priest,
        specs: [
            {
                value: "genericplayer",
                label: "Generic",
                spells: [
                    {
                        name: "1min",
                        ramp: 0,
                        duration: 15,
                        cd: 60
                    },
                    {
                        name: "1min",
                        ramp: 0,
                        duration: 15,
                        cd: 60
                    },
                    {
                        name: "1.5min",
                        ramp: 0,
                        duration: 15,
                        cd: 90
                    },
                    {
                        name: "1.5min",
                        ramp: 0,
                        duration: 15,
                        cd: 90
                    },
                    {
                        name: "2min",
                        ramp: 0,
                        duration: 15,
                        cd: 120
                    },
                    {
                        name: "2min",
                        ramp: 0,
                        duration: 15,
                        cd: 120
                    },
                    {
                        name: "3min",
                        ramp: 0,
                        duration: 15,
                        cd: 180
                    },
                    {
                        name: "3min",
                        ramp: 0,
                        duration: 15,
                        cd: 180
                    },
                    {
                        name: "4min",
                        ramp: 0,
                        duration: 15,
                        cd: 240
                    },
                    {
                        name: "4min",
                        ramp: 0,
                        duration: 15,
                        cd: 240
                    },
                    {
                        name: "Pot",
                        ramp: 0,
                        duration: 15,
                        cd: 300
                    },
                ]
            }
        ]
    },
    {
        label: "Priest",
        color: CLASS_COLORS.priest,
        specs: [
            {
                value: "hungeringspriest",
                label: "Hung. Priest",
                spells: [
                    {
                        name: "PI Void",
                        ramp: 0,
                        duration: 20,
                        cd: 120
                    }
                ]
            }
        ]
    },
    {
        label: "Mage",
        color: CLASS_COLORS.mage,
        specs: [
            {
                value: "firemage",
                label: "Fire",
                spells: [
                    {
                        name: "Combust (NF+Kind)",
                        ramp: 0,
                        duration: 10,
                        cd: 70
                    },
                    {
                        name: "Combust (NF)",
                        ramp: 0,
                        duration: 10,
                        cd: 105
                    },
                    {
                        name: "Combust (Vent)",
                        ramp: 0,
                        duration: 10,
                        cd: 120
                    },
                ]
            },
            {
                value: "frostmage",
                label: "Frost",
                spells: [
                    {
                        name: "IV",
                        ramp: 0,
                        duration: 10,
                        cd: 60
                    }
                ]
            }
        ]
    },
    {
        label: "Hunter",
        color: CLASS_COLORS.hunter,
        specs: [
            {
                value: "nfmmbm",
                label: "NF MM/BM",
                spells: [
                    {
                        name: "WS",
                        ramp: 0,
                        duration: 18,
                        cd: 120
                    }
                ]
            },
            {
                value: "kyrmm",
                label: "KYR MM",
                spells: [
                    {
                        name: "Reson. Arrow",
                        ramp: 0,
                        duration: 10,
                        cd: 60
                    },
                    {
                        name: "Trueshot",
                        ramp: 0,
                        duration: 10,
                        cd: 120
                    },
                ]
            }
        ]
    },
    {
        label: "Demon Hunter",
        color: CLASS_COLORS.dh,
        specs: [
            {
                value: "havocdh",
                label: "Havoc",
                spells: [
                    {
                        name: "Hunt",
                        ramp: 0,
                        duration: 10,
                        cd: 90
                    },
                    {
                        name: "Meta",
                        ramp: 0,
                        duration: 30,
                        cd: 240
                    },
                ]
            }
        ]
    },
    {
        label: "Druid",
        color: CLASS_COLORS.druid,
        specs: [
            {
                value: "venthbalance",
                label: "Vent Balance",
                spells: [
                    {
                        name: "Frenzy",
                        ramp: 0,
                        duration: 10,
                        cd: 180
                    },
                    {
                        name: "FoE",
                        ramp: 0,
                        duration: 8,
                        cd: 60
                    },
                ]
            },
            {
                value: "nfbalane",
                label: "NF Balance",
                spells: [
                    {
                        name: "Incarn",
                        ramp: 0,
                        duration: 10,
                        cd: 180
                    },
                    {
                        name: "Convoke",
                        ramp: 0,
                        duration: 8,
                        cd: 120
                    },
                    {
                        name: "FoE",
                        ramp: 0,
                        duration: 8,
                        cd: 60
                    },
                ]
            }
        ]
    },
    {
        label: "Rogue",
        color: CLASS_COLORS.rogue,
        specs: [
            {
                value: "ventsub",
                label: "Vent Sub",
                spells: [
                    // TODO
                    {
                        name: "Flag",
                        ramp: 0,
                        duration: 12,
                        cd: 70
                    },
                    {
                        name: "Shadow Blades",
                        ramp: 0,
                        duration: 10,
                        cd: 110
                    },
                ]
            },
            {
                value: "dashass",
                label: "Dash Ass",
                spells: [
                    {
                        name: "Vend/Flag",
                        ramp: 0,
                        duration: 10,
                        cd: 120
                    }
                ]
            },
            {
                value: "obedass",
                label: "Obed. Ass",
                spells: [
                    {
                        name: "Vendetta",
                        ramp: 0,
                        duration: 10,
                        cd: 120
                    },
                    {
                        name: "Flag",
                        ramp: 0,
                        duration: 12,
                        cd: 60
                    },
                ]
            },
        ]
    },
    {
        label: "Warlock",
        color: CLASS_COLORS.warlock,
        specs: [
            {
                value: "destro",
                label: "Destro",
                spells: [
                    {
                        name: "Infernal",
                        ramp: 0,
                        duration: 10,
                        cd: 180
                    },
                    {
                        name: "Dark Soul",
                        ramp: 0,
                        duration: 10,
                        cd: 120
                    },
                ]
            },
            {
                value: "demo",
                label: "Demo",
                spells: [
                    {
                        name: "Tyrant",
                        ramp: 10,
                        duration: 10,
                        cd: 65
                    }
                ]
            }
        ]
    },
    {
        label: "Warrior",
        color: CLASS_COLORS.warrior,
        specs: [
            {
                value: "nfwarr",
                label: "NF Warr",
                spells: [
                    {
                        name: "Ancient A.",
                        ramp: 0,
                        duration: 10,
                        cd: 90
                    },
                ]
            },
            {
                value: "kyrwarr",
                label: "Kyr Warr",
                spells: [
                    {
                        name: "Spear",
                        ramp: 0,
                        duration: 10,
                        cd: 60
                    },
                ]
            }
        ]
    },
    {
        label: "Shaman",
        color: CLASS_COLORS.shaman,
        specs: [
            {
                value: "enhwitchdoctor",
                label: "Enh Doc.",
                spells: [
                    {
                        name: "Fae",
                        ramp: 0,
                        duration: 20,
                        cd: 90
                    },
                ]
            }
        ]
    },
    {
        label: "Paladin",
        color: CLASS_COLORS.pala,
        specs: [
            {
                value: "ventprotpala",
                label: "Vent Prot",
                spells: [
                    {
                        name: "AH",
                        ramp: 0,
                        duration: 30,
                        cd: 240
                    },
                ]
            }
        ]
    },
    {
        label: "Death Knight",
        color: CLASS_COLORS.dk,
        specs: [
            {
                value: "oblitfrost",
                label: "Oblit Frost",
                spells: [
                    {
                        name: "Pillar",
                        ramp: 0,
                        duration: 10,
                        cd: 60
                    }
                ]
            },
            {
                value: "breathfrost",
                label: "Breath Frost",
                spells: [
                    {
                        name: "Pillar",
                        ramp: 0,
                        duration: 10,
                        cd: 60
                    },
                    // Must line up with Pillars
                    {
                        name: "Breath",
                        ramp: 0,
                        duration: 10,
                        cd: 120
                    },
                    // Must line up with Pillars
                    {
                        name: "Wyrm",
                        ramp: 0,
                        duration: 10,
                        cd: 180
                    },
                ]
            },
            {
                value: "necrounholy",
                label: "Nec. Unholy",
                spells: [
                    {
                        name: "Apoc",
                        ramp: 0,
                        duration: 15,
                        cd: 60
                    },
                    {
                        name: "Army",
                        ramp: 0,
                        duration: 30,
                        cd: 240
                    },
                ]
            }
        ]
    }
]

function assertUniqueSpecValues() {
    const values = PREDEFINED_ACTORS.flatMap(actor => actor.specs).map(spec => spec.value)
    const valueSet = new Set(values)

    if (valueSet.size !== values.length) {
        throw Error(`Duplicate spec values, fix`)
    }
}

assertUniqueSpecValues()
